







































































































































  import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { namespace } from 'vuex-class'
  import uuid from 'uuid-random'
  import { Currency, Products, Stocks } from '@one/types'
  import { Cart, Wishlist } from '@one/types/dist/orderpath/app'
  import inViewport from 'vue-in-viewport-mixin'
  import { ProductQuantityAndResourceId } from '../product/OneProductTileRightActions.vue'
  import UtilsMixin from '~/mixins/UtilsMixin'
  import { MappedProductStocks } from '~/store/stocks/types'
  import { ProductItem } from '~/plugins/gtm/gtm'
  import Warehouse = Stocks.Warehouse
  import StockVisibilityMode = Stocks.StockVisibilityMode
  import useUtils from '~/composables/useUtils'

  const stocks: BindingHelpers = namespace('stocks')
  const cms: BindingHelpers = namespace('cms')
  const products: BindingHelpers = namespace('products')
  const categories: BindingHelpers = namespace('categories')
  const { formatProductPreorderDate } = useUtils()

  @Component({
    mixins: [inViewport],
    components: {
      OneProductTileGallery: () =>
        import('~/components/organisms/product/OneProductTileGallery.vue'),
      OneProductTileInformation: () =>
        import('~/components/organisms/product/OneProductTileInformation.vue'),
      OneProductTileRightActions: () =>
        import('~/components/organisms/product/OneProductTileRightActions.vue'),
      OneProductStocksInfo: () => import('~/components/organisms/product/OneProductStocksInfo.vue'),
      OneProductTileRightPrice: () =>
        import('~/components/organisms/product/OneProductTileRightPrice.vue'),
      OneProductTitleLabels: () =>
        import('~/components/molecules/images/OneProductTitleLabels.vue'),
    },
  })
  export default class OneProductMinilistView extends mixins(UtilsMixin) {
    @products.Getter getProduct: any
    @stocks.Getter getWarehouse: any
    @stocks.Getter getProductStocks: any
    @stocks.Getter getProductWarehouse: any
    @stocks.Getter getProductOrderQuantityInWarehouse: any
    @stocks.Getter isEnoughProductWithBlockLabelInStock: any
    @stocks.Getter getDefaultWarehouseId: any
    @stocks.Getter getCentralWarehouse: any
    @products.Getter getProductLabels: any
    @products.Getter getProductImages: any
    @cms.Getter theme: any
    @categories.Getter getCategory: any

    elemId: string = uuid()
    showCollapse: boolean = false
    productQuantity: number = 0
    mainComponentClass = 'one-product-minilist-view'

    @Watch('inViewport.now')
    isInViewport() {
      // @ts-ignore
      if (this.inViewport.now) {
        this.$plugins.onMounted(this.mainComponentClass, this, {
          productId: this.productId,
        })
      }
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    @Prop({
      type: Boolean,
      default: false,
    })
    extended?: boolean

    @Prop({
      type: Boolean,
      default: true,
    })
    showRightSide!: boolean

    @Prop({
      type: Boolean,
      default: true,
    })
    showAddToWishlistButton?: boolean

    @Prop({
      type: Boolean,
      default: true,
    })
    showTechTriggerBtn?: boolean

    @Prop({
      type: String,
      required: true,
    })
    productId?: string

    @Prop({
      required: true,
      type: String,
    })
    unit?: string

    @Prop({
      type: Object,
    })
    prices?: Products.ProductPrice

    @Prop({
      type: Boolean,
    })
    priceLoading?: boolean

    @Prop({
      type: Boolean,
    })
    stocksLoading?: boolean

    @Prop({
      type: Object,
    })
    currency?: Currency

    @Prop({
      type: Boolean,
      default: false,
    })
    progress?: boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    progressWishlist?: boolean

    @Prop({
      type: Array,
      required: true,
    })
    carts!: Array<Cart.Responses.BasicCartInfo>

    @Prop({
      type: Array,
      required: true,
    })
    wishlists!: Array<Wishlist.Responses.BasicWishlist>

    @Prop({
      required: true,
      type: String,
    })
    loginToBuyLabel!: string

    get categoryName(): string | null {
      const category = this.getCategory(this.product.canonicalCategory)
      return category ? category.name : null
    }

    mediumPhotoExtended(id: string): string {
      return this.getProductImages(id, this.extended ? 'SMALL_300' : 'SMALL_200')
    }

    onAddToCart({ id: cartId, quantity: amountOfProducts }: ProductQuantityAndResourceId) {
      this.$emit('add-to-cart', {
        cartId,
        productId: this.product.id,
        amountOfProducts,
      })
    }

    onAddToWishlist({ id: wishlistId, quantity: amountOfProducts }: ProductQuantityAndResourceId) {
      this.$emit('add-to-wishlist', {
        wishlistId,
        productId: this.product.id,
        amountOfProducts,
      })
    }

    onProductQuantityChanged(quantity: number) {
      this.productQuantity = quantity
    }

    onProductClick(product) {
      this.$gtm.selectItem({
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand && product.brand.name,
        category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
        // @ts-ignore
        price: this.prices?.price || 0,
        // @ts-ignore
        discount: this.prices?.catalogPrice - this.price?.price,
      } as ProductItem)
    }

    warehouse(id: string) {
      return this.getProductWarehouse(this.productId, id)
    }

    getLabel(id: string) {
      return this.warehouse(id) ? this.warehouse(id).warehouseLabel : '-'
    }

    getShippingTime(id: string) {
      return this.getWarehouse(id) && this.getWarehouse(id).shippingTime
    }

    get isProductBlocked(): boolean {
      return this.getProductLabels('Block', this.productId)
    }

    get product() {
      return this.getProduct(this.productId)
    }

    get preorderDate(): string {
      return formatProductPreorderDate(this.product.preorderDate)
    }

    get stocks(): MappedProductStocks | null {
      return this.getProductStocks(this.productId)
    }

    get stockVisibilityModeHidden(): boolean {
      return this.stocks?.stockVisibilityMode === StockVisibilityMode.HIDDEN
    }

    getAvailability(id: string) {
      return this.warehouse(id)?.available
    }

    get warehouses() {
      if (!this.stocks) {
        return []
      }
      return this.stocks.warehouses.allIds
        .map((stockId: string) => ({
          id: stockId,
          unity: this.stocks!.unit,
          quantity: this.getProductOrderQuantityInWarehouse(this.productId, stockId),
          label: this.getLabel(stockId),
          shippingTime: this.getShippingTime(stockId),
          type: this.getWarehouse(stockId).type,
          available: this.getAvailability(stockId),
          stockVisibilityModeHidden: this.stockVisibilityModeHidden,
        }))
        .filter((item: any) => {
          if (this.parentWarehouseId) {
            return item.id !== this.getDefaultWarehouseId && item.id !== this.parentWarehouseId
          }

          return item.id !== this.getDefaultWarehouseId
        })
        .sort((a: any, b: any): number => {
          if (a.label < b.label) {
            return -1
          }
          if (a.label > b.label) {
            return 1
          }
          return 0
        })
    }

    get notEnoughProductStockAmount(): boolean {
      return (
        this.product &&
        this.isEnoughProductWithBlockLabelInStock(
          this.productQuantity,
          this.product.labels,
          this.product.id,
        )
      )
    }

    get parentWarehouseId(): string {
      return this.parentWarehouse?.id || ''
    }

    get hasSelectedWarehouseParent(): boolean {
      return this.parentWarehouseId !== null
    }

    get currentWarehouse(): Warehouse {
      return this.getWarehouse(this.getDefaultWarehouseId)
    }

    get parentWarehouse(): Warehouse {
      return this.currentWarehouse && this.getWarehouse(this.currentWarehouse.parent)
    }

    get firstCentralWarehouse(): string {
      return this.getCentralWarehouse && this.getCentralWarehouse[0]
    }

    get parentOrFirstWarehouseId(): string {
      return (this.parentWarehouse && this.parentWarehouse.id) || this.firstCentralWarehouse
    }

    get isSelectedWarehouseCentral() {
      return this.currentWarehouse.type.toString() === 'CENTRAL'
    }

    get labels(): any {
      return {
        firstWarehouse: this.getLabel(this.parentWarehouseId),
        defaultWarehouse: this.getLabel(this.getDefaultWarehouseId),
      }
    }

    get shippingTime(): any {
      return {
        firstWarehouse: this.getShippingTime(this.parentWarehouseId),
        defaultWarehouse: this.getShippingTime(this.getDefaultWarehouseId),
      }
    }
  }
